import { EmptyState } from '@ashniva/ui';

import { problemCopy } from '../problem-copy';

/**
 * What somebody who reaches a Repository Intelligence screen by its address, without access, reads (MASTER-SPEC
 * §14.4: hidden navigation, and 403 text if reached directly). Nothing is requested: the API would refuse it anyway.
 */
export function NoAccess() {
  const copy = problemCopy('forbidden', false);
  return (
    <div className="ri-notice" role="status">
      <EmptyState icon={copy.icon} title={copy.title} description={copy.description} />
    </div>
  );
}
